import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import Login from "./components/Login";
import Register from "./components/Register";
import TokenForm from "./components/TokenForm";
import TokenList from "./components/TokenList";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/token-form" element={<TokenForm />} />
      <Route path="/token-list" element={<TokenList />} />
    </Routes>
  </BrowserRouter>
);
